var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"bg-primary text-white",attrs:{"href":"#","id":"scroll"},on:{"scroll":_vm.handleScroll}},[_c('i',{staticClass:"fa fa-angle-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }